// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

:host,
mgt-login {
  --font-size: 14px;
  --font-weight: 600;
  --width: '100%';
  --height: '100%';
  --margin: 0;
  --padding: 12px 20px;
  --color: #323130;
  --color-hover: var(--theme-primary-color);
  --background-color: transparent;
  --background-color--hover: #edebe9;
  --popup-content-background-color: white;
  --popup-command-font-size: 12px;
  --popup-command-margin: 16px 0 0;
  --popup-padding: 24px 48px 16px 24px;
  --popup-color: #323130; }

:host .root,
mgt-login .root {
  position: relative;
  display: inline-block; }

:host .login-button,
mgt-login .login-button {
  display: flex;
  align-items: center;
  font-family: var(--default-font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  width: var(--width);
  height: var(--height);
  margin: var(--margin);
  padding: var(--padding);
  color: var(--color);
  background-color: var(--background-color);
  border: none;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s; }
  :host .login-button:hover,
  mgt-login .login-button:hover {
    color: var(--color-hover);
    --color: var(--color-hover);
    background-color: var(--background-color--hover); }
  :host .login-button:focus,
  mgt-login .login-button:focus {
    outline: 0; }
  :host .login-button:disabled,
  mgt-login .login-button:disabled {
    opacity: 0.4;
    pointer-events: none; }
  :host .login-button.no-click,
  mgt-login .login-button.no-click {
    pointer-events: none; }

:host .login-icon + span,
mgt-login .login-icon + span {
  margin-left: 6px; }

:host .popup,
mgt-login .popup {
  font-family: var(--default-font-family);
  background: var(--popup-content-background-color);
  min-width: 240px;
  z-index: 1;
  color: var(--popup-color);
  --color: var(--popup-color); }

:host .popup-content,
mgt-login .popup-content {
  display: flex;
  flex-direction: column;
  padding: var(--popup-padding); }

:host .popup-commands ul,
mgt-login .popup-commands ul {
  list-style-type: none;
  margin: var(--popup-command-margin);
  padding: 0; }

:host .popup-command,
mgt-login .popup-command {
  font-family: var(--default-font-family);
  font-size: var(--popup-command-font-size);
  font-weight: var(--font-weight);
  color: var(--theme-primary-color);
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.3s; }
  :host .popup-command:hover,
  mgt-login .popup-command:hover {
    color: var(--theme-dark-color); }

`
];
//# sourceMappingURL=mgt-login-css.js.map